module.exports = __webpack_public_path__ + "static/media/angle_left.61bcf8f9.svg";